export default __webpack_public_path__ + "static/jalebi-640c2135373a94edb7c14b170e01154d.png";